import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LineChartData } from '../../../models/ILineChartData';
import { CustomLinerChartService } from '../../../services/chart/custom-line-chart.service';
import * as shape from 'd3-shape';

@Component({
  selector: 'ff-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
  providers: [CustomLinerChartService]
})
export class LineChartComponent implements OnInit {

  /**
   * Data to display use the ChartData interface
   * Format: [{name: string, series: ChartData[]}]
   * ChartDate: {name: string, value: number}
   * @internal
   */
  @Input() data: LineChartData[] = [];

  /**
   * show or hide the legend
   * Default value: true
   * @internal
   */
  @Input() legend: boolean = true;

    /**
   * show or hide highlight dots in the chart
   * Default value: false
   * @internal
   */
     @Input() showDots: boolean = false;

  /**
   * show or hide the x axis
   * @internal
   */

  @Input() xAxis: boolean = true;

  /**
   * show or hide the y axis
   * @intenal
   */

  @Input() yAxis: boolean = true;

  /**
* show or hide the y axis label
* Default value: true
* @internal
*/

  @Input() showYAxisLabel: boolean = true;

  /**
* show or hide the x axis label
* Default value: true
* @internal
*/

  @Input() showXAxisLabel: boolean = true;

  /**
* the x axis label text
* @internal
*/

  @Input() xAxisLabel: string = '';

  /**
* the y axis label text
* @internal
*/

  @Input() yAxisLabel: string = '';

    /**
* the y axis label text
* @internal
*/

@Input() theme: string = '';

  /**
   * display a timeline control under the chart.
   * Only available if a the x scale is linear or time
   * Default Value: true
   * @internal
   */
  @Input() timeline: boolean = true;

  /**
* Chart width
* Default value: 700
* @internal
*/

  @Input() width: number = 700;

  /**
* Chart height
* Default value: 400
* @internal
*/

  @Input() height: number = 400;

  /**
* Function to execute in the parent component
* @internal
*/
  @Input() select: Function;

  /**
* Function to execute in the parent component
* @internal
*/
  @Input() activate: Function;

  /**
* Function to execute in the parent component
* @internal
*/
  @Input() deactivate: Function;

/**
* Shape from d3-shape to apply to the chart
* @internal
*/
  @Input() shape : shape.CurveFactory = shape.curveLinear;

  @ViewChild('chart') chart: any;

	ngAfterViewInit() {
    if(this.showDots){
      this.customLinearChartService.showDots(this.chart);
    }

    //Change color of legend labels
    setTimeout(() => {
      let elements = Array.from(document.getElementsByClassName('legend-label-text') as HTMLCollectionOf<HTMLElement>);
      elements.forEach(e => {
        let box = e.parentElement.firstChild as HTMLElement;
        let color = box.style.backgroundColor;
        e.setAttribute('style', 'color:' + color);
      }); 
    });
	}

  chartSize: number[] = [];

  colorScheme = {
    domain: []
  }

  constructor(private customLinearChartService: CustomLinerChartService) { }

  ngOnInit(): void {
    this.chartSize = [this.width, this.height];

    this.data.forEach(element => {
      this.random_hex_color_code(element.color);
    })


  }

  ngAfterViewChecked(): void {

  }

  random_hex_color_code = (color : string): void => {

    if (color === undefined){
      this.colorScheme.domain.push('#000000');
    } else {
      this.colorScheme.domain.push(color);
    }



  };

  onSelect = (data): void => {
    !!this.select
      ? this.select(data)
      : '';
  }

  onActivate = (data): void => {
    !!this.activate
      ? this.activate(data)
      : '';
  }

  onDeactivate = (data): void => {
    !!this.deactivate
      ? this.deactivate(data)
      : '';
  }

}
